<template>
  <div>
    <v-row>
      <v-col sm="12" cols="12">
        {{ $t("memberRegistration.step4.content.line_1") }}
      </v-col>
      <v-col sm="12" cols="12">
        {{ $t("memberRegistration.step4.content.line_2") }}
      </v-col>
    </v-row>

    <v-row v-for="p in selectedParticipants" :key="p.userId">
      <Participant :membershipTypeId="membershipTypeId" :organizationId="organizationId" :p="p" :selectedParticipants="selectedParticipants" :participants="participants" @validateNextStep="validateNextStep" />
    </v-row>

    <v-row>
      <v-col md="6" sm="6" cols="6" class="text-left">
        <v-btn
          :color="`${buttonColor}`"
          class="btn_next"
          v-model="step"
          @click="nextStep(stepBack)"
          >{{ $t("registerEvent.prev") }}</v-btn
        >
      </v-col>
      <v-col md="6" sm="6" cols="6" class="text-right">
        <v-btn
          :color="`${buttonColor}`"
          class="btn_next"
          v-model="step"
          :disabled="!isStepNextEneabled"
          @click="nextStep(stepNext)"
          >{{ $t("registerEvent.next") }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  VCol,
  VRow,
  VBtn,
} from "vuetify/lib";

import Participant from '@/components/memberRegistration/Participant.vue'

export default {
  components: {
    VCol,
    VRow,
    VBtn,

    Participant,
  },
  props: {
    step: Number,
    buttonColor: String,
    selectedParticipants: Array,
    participants: Array,
    membershipTypeId: Number,
    organizationId: Number,
    previousStep: Number,
    extraItems: Array
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    participantImagePlaceholder: '/participant/img/partPlaceholder.a4cd1320.jpg',
    isStepNextEneabled: false
  }),

  computed: {
    stepBack() {
      return this.previousStep;
    },
    stepNext() {
      // After Class (step 4), advance to either Extra Items (5) if the org
      // has any, or skip straight to Feedback (6).
      return this.extraItems.length > 0 ? 5 : 6;
    }
  },

  methods: {
    validateNextStep()
    {
      this.isStepNextEneabled = this.selectedParticipants.length == this.selectedParticipants.filter(obj => obj.selections && obj.selections.length > 0).length;
    },
    nextStep(step)
    {
      this.$emit("nextStep", step);
    },
  },
};
</script>

<style lang="scss">
    .partbg {
        background: rgba(197, 220, 218, 0.64) !important;
    }
</style>

<style scoped>
    .v-data-table header {
        background: rgba(197, 220, 218, 0.64) !important;
        color: black !important;
    }
</style>